import { useCallback, useRef, useState } from 'react'

export function useControlsVisibility() {
  const [isControlsVisible, setControlsVisibleState] = useState(false)
  const showControlsRef = useRef(false)
  const countRef = useRef(0)

  const setControlsVisible = useCallback((visible: boolean) => {
    showControlsRef.current = visible
    setControlsVisibleState(visible)
  }, [])

  const handleMouseMove = useCallback(() => {
    setControlsVisible(true)
    countRef.current = 0
  }, [setControlsVisible])

  const handleMouseLeave = useCallback(() => {
    setControlsVisible(false)
    countRef.current = 0
  }, [setControlsVisible])

  const tickAutoHide = useCallback(() => {
    if (showControlsRef.current) {
      if (countRef.current > 3) {
        setControlsVisible(false)
        countRef.current = 0
      } else {
        countRef.current += 1
      }
    }
  }, [setControlsVisible])

  return {
    isControlsVisible,
    showControlsRef,
    setControlsVisible,
    handleMouseMove,
    handleMouseLeave,
    tickAutoHide,
  }
}
